import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { STORAGE } from './constants';
import './index.scss';
import LoginPage from './pages/auth/LoginPage';
import BdClientsPage from './pages/bd-clients/BDClientsPage';
import BotAccountsPage from './pages/bot/BotAccountsPage';
// import BotActivation from './pages/bot/BotActivation';
// import BotBuilderPage from './pages/bot/BotBuilder';
import ChannelsPage from './pages/channels/ChannelsPage';
import ConfigurationPage from './pages/configuration/ConfigurationPage';
import NotFoundPage from './pages/error/NotFoundPage';
// import PaymentPage from './pages/payments/PaymentPage';
import UsersPage from './pages/users/UsersPage';
import { LocalStorageService } from './services/LocalStorageService';
// import ReportChatbotPage from './pages/reports/chatbot/ReportChatbotPage';
import SupervisorPermissionsPage from './pages/users/SupervisorPermissionsPage';
import Support from './components/Support';
import { AppContext } from './context/AppContext';
import { Toaster } from 'react-hot-toast';
import MessageLinksPage from './pages/channels/short-links/MessageLinksPage';
import SelectAccountPage from './pages/select-account/SelectAccountPage';
// import AddTemplatePage from './pages/channels/templates/AddTemplatePage';
// import TemplatesPage from './pages/channels/templates/TemplatesPage';
// import BulkSendersPage from './pages/bulk-senders/BulkSendersPage';
import BulkSendersCreatePage from './pages/bulk-senders/BulkSendersCreatePage';
import ReportAgentsPage from './pages/reports/agents/ReportAgentsPage';
import ReportTicketsPage from './pages/reports/tickets/ReportTicketsPage';
// import ReportQuizPage from './pages/reports/quiz/QuizPage';
// import PaymentsReportPage from './pages/reports/payments/PaymentsReportPage';
import CustomersReportPage from './pages/reports/customers/CustomersReportPage';
import Ticket from './components/Ticket';
import ModalCustomerInfo from './components/ModalCustomerInfo';
import FollowUpPage from './pages/follow-up/FollowUpPage';
import AccountsPage from './pages/accounts/AccountsPage';
import "./i18/i18"
import SupportPage from './pages/support/SupportPage';
import HasAccessRoute from './guards/HasAccessRoute';
import FollowUpAgentsPage from './pages/follow-up/agents/FollowUpAgentsPage';
import FollowUpTicketsPage from './pages/follow-up/tickets/FollowUpTicketsPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import EmbeddedSignup from './pages/embedded-signup/EmbeddedSignup';
// import BillingPage from './pages/reports/billing/BillingPage';
import BlacklistPage from './pages/reports/blacklist/BlacklistPage';
import TemplatesRCSPage from './pages/channels/templates/TemplatesRCSPage';
import AddTemplatePageRCS from './pages/channels/templates/AddTemplatePageRCS';
import BlacklistWordsPage from './pages/reports/blacklist-words/BlacklistWordsPage';
import DashboardOperationPage from './pages/dashboard-operation/DashboardPage';
// import ConversionPage from './pages/reports/conversion/ReportConversion'
// import FlowsAnswersPage from './pages/flows/FlowsPage';
import BotBuilderFlowsPage from './pages/flows/BotBuilderFlows';
// import ApiPage from './pages/reports/api/ReportApiPage';
// import CampaignsFollowUp from './pages/campaigns/CampaignsMonitoring';
import LicensesPage from './pages/reports/licenses/LicensesPage';

const PrivateRoute = () => {

  const location = useLocation();

  useEffect(() => {
    document.body.className = 'footer-offset has-navbar-vertical-aside navbar-vertical-aside-show-xl';

    return () => {
      document.body.className = '';
    };
  }, [])

  const session = LocalStorageService.get(STORAGE.SESSION);

  if(session && session.id === 5084 && location.pathname !== '/reports/licencias' ) {
    return <Navigate to='/reports/licencias' replace />
  }

  return !session ? <Navigate to='/auth/login' replace /> : <Outlet />;
}
const LayoutRoute = () => {

  return (
    <>
      <Outlet />
      <Support />
      <Ticket />
      <ModalCustomerInfo />
    </>
  )
}


const Layout = () => {

  const [support, setSupport] = useState({
    show: false,
    title: '',
    link: ''
  })
  const [showTicketDetail, setShowTicketDetail] = useState({
    show: false,
    ticketID: null,
    categories: null
  })
  const [showCustomerDetail, setShowCustomerDetail] = useState({
    show: false,
    account_client_id: 0
  })

  return (
    <>
      <AppContext.Provider value={
        {
          support,
          setSupport,
          showTicketDetail,
          setShowTicketDetail,
          showCustomerDetail,
          setShowCustomerDetail
        }
      }
      >
        <BrowserRouter >
          <Routes>

            <Route path="/whatsapp-business/embedded-signup" element={<EmbeddedSignup />} />
            <Route path="/auth" >
              <Route path="login" element={<LoginPage />} />
              {/* <Route path="reset-password" element={<ResetPasswordPage />} /> */}
            </Route>
            <Route path="/" element={<PrivateRoute />}>
              <Route path='/' element={<LayoutRoute />}>
                <Route path='/' element={<HasAccessRoute permission='dashboard.show' />}>
                  {/* <Route path="" element={<DashboardPage />} /> */}
                  <Route path="" element={<DashboardOperationPage />} />
                </Route>

                <Route path='/dashboard' element={<HasAccessRoute permission='dashboard.show' />}>
                  {/* <Route path="" element={<DashboardPage/>}/> */}
                  <Route path="" element={<DashboardOperationPage />} />
                </Route>

                <Route path="/reports" element={<HasAccessRoute permission={'reports.show'} />} >
                  {/* <Route path="quiz" element={<ReportQuizPage />} /> */}
                  <Route path="tickets" element={<ReportTicketsPage />} />
                  <Route path="agents" element={<ReportAgentsPage />} />
                  {/* <Route path="payments" element={<PaymentsReportPage />} /> */}
                  <Route path="customers" element={<CustomersReportPage />} />
                  {/* <Route path="chatbot" element={<ReportChatbotPage />} /> */}
                  {/* <Route path="billing" element={<BillingPage />} /> */}
                  <Route path="blacklist" element={<BlacklistPage />} />
                  <Route path="blacklist-words" element={<BlacklistWordsPage />} />
                  {/* <Route path="conversion" element={<ConversionPage />} /> */}
                  {/* <Route path="api" element={<ApiPage />} /> */}
                  <Route path="licencias" element={<LicensesPage />} />
                </Route>

                <Route path="/users" element={<HasAccessRoute permission={'user.show'} />} >
                  <Route path="" element={<UsersPage />} />
                  <Route path="supervisor/permissions" element={<SupervisorPermissionsPage />} />
                </Route>
                <Route path="/bd-clients" element={<HasAccessRoute permission={'accounts_db.show'} />} >
                  <Route path="" element={<BdClientsPage />} />
                </Route>
                {/* <Route path="/payments" element={<HasAccessRoute permission='payments.show' />}>
                  <Route path='' element={<PaymentPage />} />
                </Route> */}

                <Route path="/campaigns">
                  {/* <Route path='' element={<BulkSendersPage />} /> */}
                  {/* <Route path='/campaigns/bulk-senders' element={<BulkSendersPage />} /> */}
                  <Route path='/campaigns/create' element={<BulkSendersCreatePage />} />
                  {/* <Route path='/campaigns/flows-answers' element={<FlowsAnswersPage />} /> */}
                  <Route path='/campaigns/builder' element={<BotBuilderFlowsPage />} />
                  {/* <Route path='/campaigns/follow-up' element={<CampaignsFollowUp />} /> */}
                </Route>

                <Route path="/follow-up">
                  <Route path="" element={<FollowUpPage />} />
                  <Route path="/follow-up/agents" element={<FollowUpAgentsPage />} />
                  <Route path="/follow-up/tickets" element={<FollowUpTicketsPage />} />
                </Route>


                <Route path="/configuration">
                  {/* <Route path="" element={<AccountsConfigurationPage />} /> */}
                  <Route path='' element={<ConfigurationPage />} />
                </Route>

                <Route path="/channels" >
                  <Route path='' element={<ChannelsPage />} />
                  <Route path='link-message' element={<MessageLinksPage />} />
                  {/* <Route path='templates' element={<TemplatesPage />} /> */}
                  <Route path='templatesRCS' element={<TemplatesRCSPage />} />
                  {/* <Route path='templates/create-template' element={<AddTemplatePage />} /> */}
                  <Route path='templatesRCS/create-template' element={<AddTemplatePageRCS />} />

                  {/* <Route path='add-template' element={<AddTemplatePage />} /> */}

                </Route>

                <Route path="/configuration" element={<ConfigurationPage />} />

                {/* <Route path="/accounts" element={<AccountsPage />}  /> */}

                <Route path="/accounts" element={<HasAccessRoute onlyRoot />}  >
                  <Route path='' element={<AccountsPage />} />
                </Route>



                <Route path="/bot" element={<HasAccessRoute permission='bots.show' />}>
                  <Route path="accounts" element={<BotAccountsPage />} />
                  {/* <Route path="builder" element={<BotBuilderPage />} /> */}
                  {/* <Route path="activation" element={<BotActivation />} /> */}
                </Route>

                <Route path='support' element={<HasAccessRoute onlyRoot />}>
                  <Route path="" element={<SupportPage />} />
                </Route>

              </Route>

              <Route path="/select-account" element={<SelectAccountPage />} />

              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </BrowserRouter>

      </AppContext.Provider>

      <Toaster position="top-center" containerStyle={{ zIndex: 99999 }} />
    </>
  )
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Layout />
);
